"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadMode = exports.setupUploadModule = void 0;
var operations_1 = require("./operations");
var DEFAULT_MAX_CONCURRENT_UPLOADS = 2;
var setupUploadModule = function (config) {
    var uTypes = Object.keys(config.uploads);
    var defaultMaxConcurrentUpload = config.maxConcurrentUploads || DEFAULT_MAX_CONCURRENT_UPLOADS;
    var module = uTypes.reduce(function (acc, uType) {
        var _a;
        var _b = config.uploads[uType], _c = _b.maxConcurrentUploads, maxConcurrentUploads = _c === void 0 ? defaultMaxConcurrentUpload : _c, initiate = _b.initiate, getPartRequest = _b.getPartRequest;
        return __assign(__assign({}, acc), (_a = {}, _a[uType] = __assign({ uploadOne: (0, operations_1.uploadFile)({
                uploadType: uType,
                initiate: initiate,
                getPartRequest: getPartRequest,
                maxConcurrentUploads: maxConcurrentUploads,
            }), uploadMany: (0, operations_1.uploadFiles)({
                uploadType: uType,
                initiate: initiate,
                getPartRequest: getPartRequest,
                maxConcurrentUploads: maxConcurrentUploads,
            }) }, (config.uploads[uType].complete
            ? { completeOne: operations_1.completeOne, completeMany: operations_1.completeMany }
            : {})), _a));
    }, {});
    return module;
};
exports.setupUploadModule = setupUploadModule;
var types_1 = require("./types");
Object.defineProperty(exports, "UploadMode", { enumerable: true, get: function () { return types_1.UploadMode; } });
exports.default = exports.setupUploadModule;
